import { Component, inject, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AdminService } from '@miq/platform';
import { IOption, IRecordAccess } from '@miq/shared-models';
import { L10nTranslationModule } from 'angular-l10n';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { UpperCasePipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-record-permission-dialog',
  templateUrl: './record-permission-dialog.component.html',
  styleUrl: './record-permission-dialog.component.scss',
  imports: [
    MatButton,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    OnlyNumbersDirective,
    MatDialogActions,
    UpperCasePipe,
    L10nTranslationModule
],
})
export class RecordPermissionDialogComponent implements OnInit, OnDestroy {
  public searchRecordFC: FormControl<string | null>;
  public recordFormGroup: FormGroup<{
    recordTypeId: FormControl<string | null>;
    recordID: FormControl<string | null>;
    recordDesc: FormControl<string | null>;
  }>;
  public recordTypeOptions: IOption[];
  private readonly dialogRef = inject(MatDialogRef<RecordPermissionDialogComponent>);

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly formBuilder = inject(FormBuilder);
  private readonly data = inject<any>(MAT_DIALOG_DATA);
  private readonly adminService = inject(AdminService);
  constructor() {
    // create search form control.
    this.searchRecordFC = this.formBuilder.control('');
    // crete form group.
    this.recordFormGroup = this.formBuilder.group({
      recordTypeId: ['', Validators.required],
      recordID: ['', Validators.required],
      recordDesc: ['', Validators.required],
    });
    this.adminService.getRecordTypes().subscribe(result => {
      this.recordTypeOptions = result;
      this.cdr.markForCheck();
    });
  }
  ngOnInit() {
    /* required for static lable translation */
  }
  // form controls getters.
  public get recordTypeId() {
    return this.recordFormGroup.get('recordTypeId');
  }
  public get recordID() {
    return this.recordFormGroup.get('recordID');
  }
  public get recordDesc() {
    return this.recordFormGroup.get('recordDesc');
  }
  /**
   * Search for a record using the the record ID
   * or address as search criteria.
   */
  public searchRecord() {
    /*
     * Functionality not defined yet.
     */
  }
  /**
   * Closes the dialog sending back the record data;
   */
  public addRecord() {
    const recordPermission = { ...this.recordFormGroup.value } as unknown as IRecordAccess;
    recordPermission.statusId = 1;
    recordPermission.recordTypeVal = this.recordTypeOptions.find(f => f.key === recordPermission.recordTypeId).value;
    this.dialogRef.close(recordPermission);
  }
  /**
   * Close the dialog sanding no data.
   */
  public onCancelClick() {
    this.dialogRef.close();
  }
  ngOnDestroy() {
    /** label translation purpose added */
  }
}
